import { AddressField } from '@flos/react-ui';
import useAppState from '../../../state/appState';
import { getTempElementId } from './getTempElementId';
import HouseAddress, { AddressOption, houseAddressKeys } from './HouseAddress';
import { getDefaultAddresses } from './getDefaultAddresses';
import { useMemo, useState } from 'react';

const ADDRESS_ID: houseAddressKeys = 'showOtherAddressDanish';

export const OtherAddressDanish = ({
    elementId,
    isRequired,
    setFormValue
}: {
    elementId: string;
    isRequired: boolean;
    setFormValue: (key: string, value: AddressOption) => void;
}) => {
    const formValues = useAppState((state) => state.formValues);
    const value = HouseAddress.getValueOrDefault(formValues, elementId);
    const defaultAddress = getDefaultAddresses(ADDRESS_ID);
    const [fieldHasHadFocusAtLeastOnce, setFieldHasHadFocusAtLeastOnce] = useState(false);

    // The address component should be memorized to ensure render once
    // If render more than once the suggestion box will be displayed twice
    // The AddressField Flos component is using a thrid part component (dawa-autocomplete2)
    const memorizedAdressComponent = useMemo(
        () => (
            <AddressField
                defaultValue={value.valueOnSubmit.description}
                required={isRequired}
                onBlur={() => {
                    setFieldHasHadFocusAtLeastOnce(true);
                }}
                isValid={HouseAddress.isFieldValid(fieldHasHadFocusAtLeastOnce, formValues, elementId)}
                errorText="Adresse skal udfyldes"
                fieldEvent={(data) => {
                    const addressDawa = data.address;

                    if (!addressDawa) {
                        return;
                    }
                    const valueObject = {
                        ...defaultAddress,
                        valueOnSubmit: {
                            ...defaultAddress.valueOnSubmit,
                            description: addressDawa
                        }
                    };

                    // Set address from DAWA service
                    setFormValue(elementId, valueObject);

                    // Used to let the user click between all the
                    // address boxes and still maintain the manually
                    // entered address
                    setFormValue(getTempElementId(elementId, ADDRESS_ID), valueObject);
                }}
                onChange={(event) => {
                    if (event.target.value) {
                        // Actual values will be handled by fieldEvent
                        return;
                    }

                    // FieldEvent method will not be triggered if the user enters an empty string
                    // The onChange method is used to specifically handle empty string scenario
                    // Non-empty string input will be handle in fieldEvent
                    //
                    // @TODO
                    //  - YIJ - What if we put an else-statement into the fieldEvent?
                    const valueObject = {
                        ...defaultAddress,
                        valueOnSubmit: {
                            ...defaultAddress.valueOnSubmit,
                            description: ''
                        }
                    };
                    setFormValue(elementId, valueObject);
                    setFormValue(getTempElementId(elementId, ADDRESS_ID), valueObject);
                }}
            />
        ),
        /* eslint-disable react-hooks/exhaustive-deps */
        [fieldHasHadFocusAtLeastOnce]
    );

    return (
        <>
            {/* Call the memoized address box */}
            {memorizedAdressComponent}
        </>
    );
};
